import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';
import { useA11ySelector } from '@sg/a11y-helpers';
import { theme } from '@sg/garnish';

/**
 * Container for the bag promo rewards
 */
export const BagPromoRewardsContainer = (props: ViewProps) => {
  const a11ySelector = useA11ySelector('bag.rewards.container');

  return (
    <View style={styles.container} {...a11ySelector.props}>
      {props.children}
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingVertical: theme.spacing['6'],
    gap: theme.spacing['4'],
    borderBottomColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    borderBottomWidth: theme.spacing['2'],
    marginHorizontal: -theme.spacing['4'],
    paddingHorizontal: theme.spacing['4'],
  },
});
